import React from 'react';
import { useSelector } from 'react-redux';

const MapSelectionLabel = () => {
  const mapSelection = useSelector((state) => state.filters.mapSelection);

  return (
    <label htmlFor="minimapShape" className="nameRegion">
      {mapSelection?.label}
    </label>
  );
};

export default MapSelectionLabel;
